import React, { Component } from "react";
import { Floating, translate } from '@haldor/ui';
import { connect } from "react-redux";

import { addError } from "actions";
import { saveBlocksOnReference } from 'actions/blocks';
import { createBulkPlans } from 'actions/plans';
import { createAssessmentBlock } from "actions/blocks";

import { Form, Field } from "react-final-form";

import Select from "components/Inputs/select";

import DatePickerFromTo from "../Partials/DatePickerFromTo";
import MultipleSectionSelector from "../Partials/MultipleSectionSelector";
import TeacherAdjustments from "containers/AdditionalAdjustments/Display/TeacherAdjustments";
import BlockEditor from 'components/BlockEditor';
import BlockAssessments from 'components/BlockAssessments';
import BlockPurpose from "components/Inputs/BlockPurposeField";
import BlockCoreContentField from "components/Inputs/BlockCoreContentField";
import { clearSelectedSections } from "actions/sections";

import moment from "moment";

import { Expandable, Spinner } from "UI";
import { Icon, Button, Checkbox } from '@haldor/ui';
import api from "lib/api";
import { Stack } from "@mui/material";
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';

import Swal from 'sweetalert2';

class MultiplePlanForm extends Component {

	constructor(props) {
		super(props);

		this.state = {
			dateStart: null,
			dateEnd: null,
			status: null,
			sections: [],
			associatedMatrices: [],
			loading: false,
			selectedCoreContent: [],
			additionalAdjustmentsExpanded: false
		};

		this.formRef = null;
	}


	componentWillUnmount = () => {
		this.props.clearSelectedSections();
	}

	handleAdditionalAdjustmentsToggle = (expanded) => {
		this.setState({ additionalAdjustmentsExpanded: expanded });
	}

	/* Redux form functions */
	required = value => {
		if (typeof value !== "undefined" && value !== "") {
			if (value.length > 199) {
				// Field failed validation, return error for this field (String)
				return this.props.translate("field-max-200-chars");
			}

			// Field passes validation, return a undefined error for this field
			// Rule: Not undefined and not an empty string and not over 200 characters
			return undefined;
		}

		// Field failed validation, return error for this field (String)
		return this.props.translate("field-needs-input");
	};

	submit = async (values) => {
		const preparedData = { ...values };
		preparedData.timeStart = moment(this.state.dateStart).startOf('day');
		preparedData.timeEnd = moment(this.state.dateEnd).endOf('day').subtract(1, 'minute');
		preparedData.sections = this.state.sections.map(s => ({ ...s, courses: [] }));
		return new Promise(async (resolve) => {
			const executeSubmit = async (data) => {
				try {
					let blocks = data.blocks ? [...data.blocks] : [];
					let assessmentBlocks = data.assessmentBlocks ? [...data.assessmentBlocks] : [];
					let promises = [];

					for (const block of blocks) {
						if (block.type === 'Haldor.Blocks.Assignment' && block.resources) {
							const updatedResources = [];
							for (const resource of block.resources) {
								if (resource.existing) {
									for (const aBlock of assessmentBlocks) {
										const assignmentId = resource['@odata.type'] === 'haldor.assignment.block.teamsassignment'
											? (await api.get(`assignments/${resource.id}/details`)).data.id
											: resource.id;

										promises.push(this.props.createAssessmentBlock(aBlock, assignmentId, 'ASSIGNMENT'));
									}
								}
								updatedResources.push({ id: resource.id, '@odata.type': resource['@odata.type'] });
							}
							block.resources = updatedResources;
						}
					}

					await this.props.createBulkPlans(data);

					if (this.props.createdPlans && blocks.length > 0) {
						this.props.createdPlans.forEach((createdPlan) => {
							promises.push(this.props.saveBlocksOnReference(blocks, createdPlan.id, 'PLAN'));

							assessmentBlocks.forEach((aBlock) => {
								promises.push(this.props.createAssessmentBlock(aBlock, createdPlan.id, 'PLAN'));
							});
						});
					}

					await Promise.all(promises);

					this.props.onAbort(true, true);
					resolve();

				} catch (error) {
					const result = await Swal.fire({
						title: this.props.translate('The form could not be saved'),
						text: this.props.translate('Something went wrong when we tried to save the form. Please check your connection and try again.'),
						showCancelButton: true,
						confirmButtonText: this.props.translate('Try saving again'),
						cancelButtonText: this.props.translate('Cancel')
					});

					if (result.isConfirmed) {
						return executeSubmit(data);
					} else {
						resolve();
					}
				}
			};

			return executeSubmit(preparedData);
		});
	};


	/* Begin custom endpoint input events */
	onDescriptionChange = content => {
		this.setState({ description: content });
	};

	onDateChange = dates => {
		this.setState({ dateStart: dates.start, dateEnd: dates.end });
	};

	onStatusSelect = event => {
		this.setState({ status: event.target.value });
	};

	onCoreContentChange = (values) => {
		this.setState({ selectedCoreContent: values });
	};
	/* End custom input change events */
	renderInput = ({
		input,
		label,
		type,
		placeholder,
		meta: { touched, error, warning }
	}) => {
		return (
			<div>
				<input
					type={type}
					{...input}
					placeholder={placeholder || label}
					onKeyPress={e => {
						if (e.key == 'Enter') {
							e.preventDefault();
						}
					}}
					style={
						touched && error
							? {
								border: "1px solid red"
							}
							: {}
					}
				/>

				{touched &&
					((error && (
						<span style={{ marginTop: "1rem", color: "red" }}>
							{error}
						</span>
					)) ||
						(warning && (
							<span style={{ marginTop: "1rem", color: "red" }}>
								{warning}
							</span>
						)))}
			</div>
		);
	};

	onSectionsChange = (groups) => {
		this.setState({ sections: groups });
		this.reCheckAutoAssign(groups);
	};

	reCheckAutoAssign = (groups) => {
		if (this.state != null) {
			let enableAutoAssign = groups != null && groups.length > 0 && (groups.every(section => section.allStudentsSelected));

			if (!enableAutoAssign) {
				this.formRef.mutators.setAutoAssignStudents(false);
			}

			this.setState({ enableAutoAssign });
		}
	}


	onAddSectionCourse = (newGroups) => {
		let { sections } = this.state;

		sections.forEach(section => {
			let newData = newGroups.find((group) => {
				return group.id == section.id;
			});

			if (newData != null) {
				section.courses = newData.courses;
			}

			return section;
		});

		this.setState({ sections });
	}

	render() {
		var statuses = this.props.status.planningStatus.filter(t => t.selectable);

		let groups = [];
		if (this.state.sections.length > 0) {
			this.state.sections.forEach(section => groups.push(section.id));
		}

		if (this.state.loading) {
			return <Spinner center />;
		}

		let disabledBlocks = [];
		if (groups.length == 0 || groups.length > 1) {
			disabledBlocks.push({ name: 'Haldor.Blocks.Assignment', text: 'Before the planning is saved, you can only add assignments if you have selected one (1) group. When the planning is saved, you can go into the planning for each group and assign assignments.' });
		}

		/**
		 * Enable the auto assign option if all groups have all students selected
		 */
		let enableAutoAssign = this.state.sections.length > 0 && this.state.sections.every(section => section.allStudentsSelected);

		return (
			<div className="form-container form">
				<Form
					onSubmit={this.submit}
					mutators={{
						setStatusDraft: (args, state, utils) => {
							utils.changeValue(state, 'status', () => 'PLANNING_DRAFT');
						},
						setStatusOpen: (args, state, utils) => {
							utils.changeValue(state, 'status', () => 'PLANNING_OPEN');
						},
						setAutoAssignStudents: (args, state, utils) => {
							utils.changeValue(state, 'autoAssignStudents', () => args[0]);
						},
					}}
					initialValues={this.props.initialValues}
					render={({ handleSubmit, form, valid, submitting, initialValues }) => {
						this.formRef = form;

						let disableGroups = false;
						let blockValues = form.getFieldState('blocks')?.value;
						let assessmentBlocks = form.getFieldState('assessmentBlocks')?.value;
						let subjects = [];
						if (assessmentBlocks?.length > 0) {
							assessmentBlocks?.forEach((content) => {
								content?.resources?.forEach(resources => {
									if (resources?.value != null) {
										if (subjects.indexOf(resources.value?.subjectId) == -1) {
											subjects.push(parseInt(resources.value?.subjectId));
										}
									}
								})
							});
						}

						if (blockValues != null && blockValues.length > 0) {
							disableGroups = blockValues.findIndex(block => block.type == 'Haldor.Blocks.Assignment') > -1;
						}
						return (
							<form onSubmit={handleSubmit} className="form form-component">
								{submitting ? (
									<div className="is_sending">
										<p>
											<span className="loading-spinner" />
										</p>
									</div>
								) : null}

								<Expandable
									contentStyles={{ padding: "1em 0rem" }}
									contentStylesClosed={{ padding: "0" }}
									headerStyles={
										this.state.error != null
											? { border: "1px solid red" }
											: {}
									}
									whiteBackground={true}
									title={this.props.translate("choose-groups")}
									open
									ignorePropsUpdate
								>
									<MultipleSectionSelector
										onChange={this.onSectionsChange}
										disabled={disableGroups}
										type="plan"
									/>

									{disableGroups ?
										<div className="group-selector-info">
											<Icon name="Alert" />
											{this.props.translate("To be able to add or delete groups, you must first delete the assignments that are in this plan. Assignments that you have already created are saved outside the planning and are searchable.")}
										</div>
										: null}
								</Expandable>

								<div className="form-row mt-4 mb-4">
									<Field name="autoAssignStudents" type="checkbox">
										{({ input }) => {
											return (
												<Stack direction="row" sx={{
													justifyContent: "flex-start",
													alignItems: "center",
												}} spacing={2}>

													<Checkbox
														{...input}
														onChange={(event) => {
															input.onChange(event);
														}}
														value={input.checked}
														disabled={!enableAutoAssign}
														checked={input.checked}
														label={this.props.translate(
															'The plan should also be assigned to students who join the selected groups.'
														)}
													/>
													<div className="helper-text">
														<Floating trigger={(<HelpOutlineRoundedIcon sx={{ fontSize: '1.3rem' }} />)}>
															{this.props.translate('For new students to be automatically assigned to the plan, entire groups must be selected, meaning all students in the selected groups.')}
														</Floating>
													</div>
												</Stack>
											)
										}
										}
									</Field>
								</div>

								{this.props.editView && initialValues.status != "PLANNING_DRAFT" ?
									<div className="form-row">
										<Select
											name="type"
											label={this.props.translate("status")}
											dataType="plan"
											options={statuses}
											placeholder={false}
											onChange={this.onStatusSelect}
											selectedValue={initialValues.status}
										/>
									</div>
									: null}

								<div className="form-row">
									<DatePickerFromTo
										type="plan"
										onChange={this.onDateChange}
										values={{
											timeStart: this.state.dateStart,
											timeEnd: this.state.dateEnd,
										}}
									/>
								</div>

								<div className="form-row input">
									<label>{this.props.translate("title")}*</label>

									<Field
										component={this.renderInput}
										type="text"
										name="title"
										placeholder={this.props.translate("title")}
										validate={this.required}
									/>
								</div>

								<div className="form-divider" />

								<Expandable title={this.props.translate('Assessments')}>
									<Field
										component={BlockAssessments}
										name="assessmentBlocks"
									/>
								</Expandable>

								<Expandable title={this.props.translate('purpose')}>
									<div className="form-row" style={{ padding: 0, marginBottom: "1em" }}>
										<div className="conditional-groups-container">
											<Field
												name="viewablePurpose"
												component={Checkbox}
												label={this.props.translate("Show purpose to students and guardians")}
											/>
										</div>
									</div>

									<Field
										component={BlockPurpose}
										name="purpose"
										assessmentBlocks={assessmentBlocks}
									/>
								</Expandable>

								<Expandable title={this.props.translate("central-content")}>
									<div className="form-row" style={{ padding: 0, marginBottom: "1em" }}>
										<div className="conditional-groups-container">
											<Field
												name="viewableCoreContent"
												component={Checkbox}
												label={this.props.translate("Show-subject-lesson-content-to-students-and-guardians")}
											/>
										</div>

										<div style={{ clear: "both" }} />
									</div>

									<Field
										component={BlockCoreContentField}
										name="associatedCoreContent"
										onChange={this.onCoreContentChange}
									/>
								</Expandable>

								{this.props.services.additionalAdjustments ?
									<Expandable
										title={this.props.translate("additional-adjustments")}
										onChange={this.handleAdditionalAdjustmentsToggle}
									>
										{this.state.additionalAdjustmentsExpanded && (
											<TeacherAdjustments disableCommenting={true} groups={groups} subjects={subjects} />
										)}
									</Expandable>
									: null}

								<Field
									component={BlockEditor}
									name="blocks"
									disabled={disabledBlocks}
									planningAssessments={assessmentBlocks?.length > 0 ? assessmentBlocks : []}
									selectedCoreContent={this.state.selectedCoreContent}
									sections={this.state.sections}
									user={this.props.currentUser}
									groupId={groups.length > 0 ? groups[0] : null}
								/>

								<div className="form-divider" />

								<div className="form-row spacing submit">
									<Button
										onClick={(e) => {
											e.preventDefault();
											form.mutators.setStatusOpen();
											handleSubmit();
										}}
										disabled={submitting || !valid || this.state.sections.length == 0}
									>
										{this.props.translate("publish")}
									</Button>

									<Button
										onClick={(e) => {
											e.preventDefault();
											form.mutators.setStatusDraft();
											handleSubmit();
										}}
										type="secondary"
										disabled={submitting || !valid || this.state.sections.length == 0}
									>
										{this.props.translate("save-draft")}
									</Button>

									<div className="align-right">
										<Button
											type="secondary"
											onClick={e => {
												e.preventDefault();
												this.props.onAbort(false);
											}}
										>
											{this.props.translate("Cancel")}
										</Button>
									</div>
								</div>
							</form>
						)
					}}
				/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
		status: state.status.status,
		services: state.Services.availableServices,
		createdPlans: state.planning.createdPlans,
		selectedSections: state.sections.selected,
		currentUser: state.user.currentUser,
		initialValues: {
			viewablePurpose: false,
			viewableCoreContent: true,
		},
	};
}

export default connect(mapStateToProps, {
	createBulkPlans,
	addError,
	saveBlocksOnReference,
	createAssessmentBlock,
	clearSelectedSections
})(MultiplePlanForm);